import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles<Theme, { isDisabled: boolean }>(theme => ({
  sendGiftsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flex: 1,
    background: ({ isDisabled }) => (isDisabled ? '#7C7C7C' : '#6CCCCB'),
    borderRadius: '16px',
    padding: '28px 32px',
    position: 'relative',
    alignItems: 'center',
    boxShadow: '0px 4px 4px #00000005',
    '&::before': {
      content: "''",
      position: 'absolute',
      width: '109px',
      height: '128px',
      background: '#FFFFFF26 0% 0% no-repeat padding-box',
      right: '45%',
      top: '0%',
    },
  },
  squares: {
    position: 'absolute',
    width: '109px',
    height: '128px',
    background: '#FFFFFF26 0% 0% no-repeat padding-box',
    right: '39%',
  },
  sendGiftsWrapper: {},
  sendGiftsButtons: {
    display: 'block',
    '& button': {
      width: 'auto',
      color: '#000000',
      background: '#FFFFFF',
      fontFamily: 'Roboto,Poppins, Open Sans',
      fontWeight: 600,
      letterSpacing: '0px',
      padding: '15px 22px',
    },
    '& button:hover': {
      backgroundColor: '#def3f3 !important',
    },
  },
  singleGiftsButton: {},
  bulkGiftsButton: {
    margin: '0 0 0 26px',
    [theme.breakpoints.down(1680)]: {
      margin: '10px 0 0 0',
      display: 'block',
    },
    [theme.breakpoints.down(1422)]: {
      margin: '0 0 0 26px',
      display: 'inline',
    },
  },
  sendGiftsTitle: {
    color: '#FFFFFF',
    letterSpacing: '0px',
    // font: 'normal normal medium 26px/32px Roboto',
    fontFamily: 'Roboto,Poppins, Open Sans',
    fontSize: '26px',
    fontWeight: 500,
    marginBottom: '33px',
    '& p': {
      margin: '0 0 12px 0',
    },
  },
  sendGiftsIcon: {
    width: '120px',
    height: '120px',
    position: 'relative',
    '&::before': {
      content: "''",
      position: 'absolute',
      width: '6px',
      height: '6px',
      borderRadius: '50%',
      outline: '6px solid #FFFFFF26',
      background: '#FFFFFF 0% 0% no-repeat padding-box',
      top: '8%',
    },
    '&::after': {
      content: "''",
      position: 'absolute',
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      background: 'transparent linear-gradient(151deg, #FFFFFF 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box;',
      top: '8%',
      right: '8%',
    },
  },
  svgIcon: {
    width: '100%',
    height: '100%',
  },
  dots: {
    position: 'relative',
    '&::after': {
      content: "''",
      position: 'absolute',
      width: '6px',
      height: '6px',
      borderRadius: '50%',
      background: '#FFFFFF 0% 0% no-repeat padding-box',
      bottom: '27px',
      left: '6px',
    },
    '&::before': {
      content: "''",
      position: 'absolute',
      width: '3px',
      height: '3px',
      borderRadius: '50%',
      background: '#FFFFFF 0% 0% no-repeat padding-box',
      bottom: '27px',
      right: '6px',
    },
  },
}));
